import Vue from "vue";
import App from "./App.vue";
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from 'axios'
import md5 from 'js-md5';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import UrlEncode from './utils/plugin/UrlEncode.js'

Vue.use(VueAwesomeSwiper)
Vue.prototype.$BUS=new Vue()
Vue.prototype.$md5 = md5;
Vue.use(ElementUI, { size: "small" });
Vue.prototype.$axios=axios
Vue.prototype.$UrlEncode = UrlEncode;

new Vue({
  render: (h) => h(App),
  store,
  router,
}).$mount("#app");
